// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router, { initDynamicRoutes } from './router'

import store from '@/store'
import axios from './utils/axios'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.prototype.$http = axios
Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
async function initializeApp() {
  // await initDynamicRoutes()
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
  })
}

initializeApp()


// WEBPACK FOOTER //
// ./src/main.js